import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { EchartService } from '@nimbus-library/features/charts/services/echart.service';
import { IInputDropDownOption } from '@nimbus-library/features/shared/components/material/input-dropdown/input-dropdown.component';
import { DateFormat, Language, languageTranslationKeys } from '../../models/enums/language.enum';

@Injectable()
export class LokalizeMapperService {
  public constructor(
    private readonly echartService: EchartService,
    private readonly translateService: TranslateService,
  ) {}

  public mapToDateFormatOption(format: DateFormat): IInputDropDownOption<string> {
    return {
      id: format,
      name: `${this.translateService.instant(languageTranslationKeys[format])} - ${this.echartService.getDateTimeFormat('dateTime', format).format(moment().hours(14).toDate())}`,
    };
  }

  public mapToLanguageOption(language: Language): IInputDropDownOption<string> {
    return {
      id: language,
      name: `${this.translateService.instant(languageTranslationKeys[language])}`,
    };
  }
}
